import { ITagResult } from '~src/httpClient/serverApi/types/IResponse';
import { TagRequest } from '~src/httpClient/TAG/TagRequest';

export interface ISiteSMTPSettings {
  server_url: string;
  server_password: string;
  server_port: number;
  server_username: string;
  sender_local_name: string;
  sender_friendly_name: string;
  custom_domain: string;
}

export class SetSiteSMTPCredentialRequest extends TagRequest<ISetSiteSMTPCredentialRequest, ITagResult> {
  constructor(params: ISetSiteSMTPCredentialRequest) {
    super('monolith_grpc', 'setSiteSMTPCredential', params);
  }
}

export interface ISiteLuidRequest {
  site_luid: string;
}

type ISetSiteSMTPCredentialRequest = ISiteSMTPSettings & ISiteLuidRequest;

